import React from 'react';
import {Body, designSystemToken} from '@lightricks/react-design-system';
import styles from './CreatorCategories.module.scss';

type CreatorCategoriesProps = {
  categories: string[];
};

const MAX_CATEGORIES = 3;

function CreatorCategories({categories}: CreatorCategoriesProps) {
  const categoriesString = categories
    ? categories.slice(0, MAX_CATEGORIES).join(' · ')
    : '';
  return (
    <Body
      size="lg"
      color={designSystemToken('semantic.fg.secondary')}
      className={styles.creatorCategory}
    >
      {categoriesString}
    </Body>
  );
}

export default CreatorCategories;
